import { createContext, type ReactNode } from 'react'

export interface ConfirmOptions {
  title: string
  /**
   * What is about to happen. A node rather than a string so a caller can spell
   * out a list of consequences, which is the case that actually needs a dialog.
   */
  body: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  /**
   * Styles the confirm button as destructive. Semantic rather than a palette
   * colour so call sites describe the action, not the theme.
   */
  destructive?: boolean
}

/** Resolves true when confirmed, false when cancelled or dismissed. */
export type ConfirmContextValue = (options: ConfirmOptions) => Promise<boolean>

// Kept in its own module so `useConfirm` can consume the context without
// importing the provider (which would pull MUI into every consumer's graph).
export const ConfirmContext = createContext<ConfirmContextValue | null>(null)
